import { ROUTE_REGION_AND_BUILDING_DATA } from "../Routes/Routes";
import NavListItem from "../../NavigationMenu/NavListUtility/NavListItem";
import GridViewIcon from '@mui/icons-material/GridView';

/**
 * @file Localizes the management of the UI for navigation label in side-panel Navigation Link in NavList.js.
 */

export const BuildingsNavigationLink = ({ navModules }) => {
    return (
        <NavListItem
            title={ROUTE_REGION_AND_BUILDING_DATA.title}
            destination={ROUTE_REGION_AND_BUILDING_DATA.withSlash}
            icon={<GridViewIcon />}
            allowed={navModules?.includes(ROUTE_REGION_AND_BUILDING_DATA.module)}
            itemButtonId="bt_region_and_building_data_001"
        />
    );
};